<div class="tagged-container"
  [ngClass]="{
    'success': type === 'success',
    'danger': type === 'danger',
    'grey': type === 'grey',
  }"
>
  <span class="tagged-text"><ng-content></ng-content></span>
</div>
